/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 * @enum {string}
 */
export var SheetRowPredicateType;
(function (SheetRowPredicateType) {
    SheetRowPredicateType["And"] = "AND";
    SheetRowPredicateType["Or"] = "OR";
    SheetRowPredicateType["Not"] = "NOT";
    SheetRowPredicateType["DimensionTag"] = "DIMENSION_TAG";
    SheetRowPredicateType["Downstream"] = "DOWNSTREAM";
})(SheetRowPredicateType || (SheetRowPredicateType = {}));
export function SheetRowPredicateTypeFromJSON(json) {
    return SheetRowPredicateTypeFromJSONTyped(json, false);
}
export function SheetRowPredicateTypeFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function SheetRowPredicateTypeToJSON(value) {
    return value;
}
